import React from "react";
import {useLocation} from "react-router-dom";


function PaymentSuccess(props) {
  const { state, t, values } = props;
  
      
  const search = useLocation().search;
  const payment=new URLSearchParams(search).get('payment');

  const downloadReceipt = () => {
    window.open(state.printReceiptUrl, "_blank");
  }
  return (
    <div className="row justify-content-md-center mt-3">
      <div className="col-sm-12 col-md-8">
        <div className="payment-summary p-4">
          <div className="row">
            <div className="col-sm-4">
              <img
                src="./images/payment-successful.svg"
                alt="payment success"
                className="success-icon"
              />
            </div>

            <div className="col-sm-6 dir-left">
              <div className="row">
                {
                  !payment && <div className="col-sm-12 mt-3">
                    <h2>{t("PAYMENT_SUCCESSFUL")}</h2>

                    <div className="col-sm-12 my-4">
                      <p className="p-text">{t("ADDITIONAL_PAYMENT_INFO")}</p>

                    </div>
                    <div className="col-sm-12">
                      <button
                        className="btn btn-primary btn-awb-download"
                        onClick={downloadReceipt}                    >
                        {t("DOWNLOAD_RECEIPT")}
                      </button>
                    </div>
                  </div>
                }
                 {
                  payment==='cash' && <div className="col-sm-12 mt-3">
                    <h2>{t("CASH_DELIEVERY_SUCCESSFUL")}</h2>
                    <div className="col-sm-12 my-4">
                      <p className="p-text">{t("CASH_ADDITIONAL_PAYMENT_INFO")}</p>
                    </div>
                  
                  </div>
                }
              </div>
            </div>


          </div>
        </div>
      </div>
      <div className="download-app-sec col-sm-12 col-md-4 my-3 mt-md-0 ">
        <div className="p-3">
          <div className="row">
            <div className="col-sm-12">
              <img src="./images/app-download-img.svg" alt="app download" />
            </div>
            <div className="col-sm-12 mt-3">
              <h3>
                {t("MANAGE_AND_TRACK_YOUR_SHIPMENTS_EASILY")}
                <br />
                <strong>{t("DOWNLOAD_THE_EMX_APP")}</strong>
              </h3>
            </div>
            <div className="col-sm-12">
              <a href={t("REACT_APP_EP_APP_DOWNLOAD_URL")} target="_blank" className="a-link" rel="noreferrer">{t("LEARN_MORE")}</a>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccess;
